import React from 'react';
import { tabList } from './FinanceTabs';
import { motion } from 'framer-motion';
import { Text } from 'components/Elements';
import { X } from 'react-feather';

export const FinanceFilters = ({
  activeTab,
  inactiveStates,
  activeFilter,
  deepFilter,
  handleFilterChange,
  setInactiveStates,
  setActiveFilter,
  setDeepFilter,
}) => {
  if (activeTab === tabList[0]?.id) {
    return (
      <motion.div
        key="currencies-filters"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col md:flex-row  p-1 px-3 items-center space-x-4 space-y-2 md:space-y-0 text-white"
      >
        {inactiveStates ? (
          <div className="flex items-center space-x-1">
            <Text variant="caption" className="text-white">
              Inactive states
            </Text>
          </div>
        ) : (
          <div className="flex items-center space-x-1">
            {['all', 'waitlist', 'active', 'inactive'].map((option) => (
              <label key={option} className="flex items-center space-x-1">
                <input
                  type="radio"
                  name="currencyFilter"
                  value={option}
                  checked={activeFilter === option}
                  onChange={() => handleFilterChange(option)}
                  className="accent-cyan-400"
                />
                <span className="capitalize text-white">{option}</span>
              </label>
            ))}
          </div>
        )}
        {activeFilter === 'inactive' && (
          <motion.div
            key="deep-filter"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="bg-white/10 dark:bg-white/10 border border-white/20 dark:border-white/10 backdrop-blur-sm rounded-full px-2 py-1"
          >
            <div className="flex items-center space-x-2 text-sm text-white">
              {[
                { value: '0', label: 'Not Set Up' },
                { value: '2', label: 'Deactivated' },
                { value: '4', label: 'Setup Pending' },
              ].map((group) => (
                <label
                  key={group.value}
                  className="flex items-center space-x-1"
                >
                  <input
                    type="radio"
                    name="deepFilter"
                    value={group.value}
                    checked={deepFilter === group.value}
                    onChange={() => setDeepFilter(group.value)}
                    className="accent-cyan-400"
                  />
                  <span>{group.label}</span>
                </label>
              ))}
            </div>
          </motion.div>
        )}
        {activeFilter === 'inactive' && (
          <button
            type="button"
            onClick={() => {
              setInactiveStates(false);
              setActiveFilter('all');
              setDeepFilter(null);
            }}
            className="text-white hover:text-red-500"
          >
            <X size={16} />
          </button>
        )}
      </motion.div>
    );
  } else if (activeTab === tabList[1]?.id || activeTab === tabList[3]?.id) {
    return (
      <motion.div
        key="generic-filters"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex items-center space-x-4 px-4 py-2 rounded-xl text-white"
      >
        {['all', 'active', 'inactive'].map((option) => (
          <label key={option} className="flex items-center space-x-1">
            <input
              type="radio"
              name={`${activeTab}-filter`}
              value={option}
              checked={activeFilter === option}
              onChange={() => handleFilterChange(option)}
              className="accent-cyan-400"
            />
            <span className="capitalize text-white">{option}</span>
          </label>
        ))}
      </motion.div>
    );
  } else if (activeTab === tabList[2]?.id) {
    return (
      <motion.div
        key="payment-filters"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col md:flex-row items-center space-x-4 space-y-2 md:space-y-0  px-4 py-2 rounded-xl text-white"
      >
        <div className="flex items-center space-x-2">
          {['all', 'active', 'inactive'].map((option) => (
            <label key={option} className="flex items-center space-x-1">
              <input
                type="radio"
                name="paymentMethodFilter"
                value={option}
                checked={activeFilter === option}
                onChange={() => handleFilterChange(option)}
                className="accent-cyan-400"
              />
              <span className="capitalize text-white">{option}</span>
            </label>
          ))}
        </div>
      </motion.div>
    );
  }
};
